import React from "react";
import { Photo } from "./types";
import _ from "lodash";
import InfiniteScroll from "react-infinite-scroll-component";
import MobilePhotoGallery from "./MobilePhotoGallery";
const gssNewLoader = require("../../assets/gss-loader.gif");

const Photos = ({
  photos,
  hasMore,
  loadPhotos,
  trackTelemetry,
  isAuthorizedForDirectDownloads,
  userId,
  primaryColor,
  reset,
  parentName,
  showFavIcon,
  canShowGuestEmailModal,
  securedOrgView,
  registerGuestUserAPI,
  setGuestUserId,
  eventClickable,
  disableSelectIcon,
  secureAccessToken
}: {
  photos: Photo[];
  hasMore: boolean;
  loadPhotos: () => void;
  trackTelemetry: boolean;
  isAuthorizedForDirectDownloads: boolean;
  userId?: number;
  primaryColor?: string;
  reset?: boolean;
  parentName?: string;
  showFavIcon?: boolean;
  canShowGuestEmailModal: (photo: any) => boolean;
  securedOrgView?: boolean;
  registerGuestUserAPI: string;
  setGuestUserId: (userId: number) => void;
  eventClickable: boolean | undefined;
  disableSelectIcon?: boolean;
  secureAccessToken?: string;
}) => {
  return (
    <div className="dv-album-wrap">
      <InfiniteScroll
        dataLength={photos.length}
        next={loadPhotos}
        hasMore={hasMore}
        scrollThreshold={0.7}
        loader={
          <div
            className="egm-loader gss-loader dv-section-footer loading"
            style={{ clear: "both" }}
          >
            <img className="photos-date-img" src={gssNewLoader} />
          </div>
        }
      >
        <MobilePhotoGallery
          photos={photos}
          primaryColor={primaryColor}
          trackTelemetry={trackTelemetry}
          isAuthorizedForDirectDownloads={isAuthorizedForDirectDownloads}
          userId={userId}
          reset={reset}
          parentName={parentName}
          showFavIcon={showFavIcon}
          canShowGuestEmailModal={canShowGuestEmailModal}
          securedOrgView={securedOrgView}
          registerGuestUserAPI={registerGuestUserAPI}
          setGuestUserId={setGuestUserId}
          eventClickable={eventClickable ?? false}
          disableSelectIcon={disableSelectIcon}
          secureAccessToken={secureAccessToken}
        />
      </InfiniteScroll>
    </div>
  );
};

export default Photos;
